export const fetchCampaignsFeed = (welletContext, body) => {
  try {
    const response = welletContext.apis.tickets.post(`/campaign/feedCampaigns`, body);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const fetchCampaignsFeedShows = (welletContext) => {
  try {
    const response = welletContext.apis.tickets.get(`/campaign/feedCampaigns/header`);
    return response;
  } catch (error) {
    console.error(error);
  }
};